<template>
  <v-sheet class="mx-auto search-basic-form" max-width="1180px">
    <v-form @submit.prevent="search" ref="form">
      <div
        class="grid-list-1"
        :class="{ rural: ['/rural'].includes($route.path) }"
      >
        <BusinessSelect
          hide-details
          :clearable="['/rural'].includes($route.path)"
        />
        <CategoriesSelect hide-details />
        <CitiesSelect hide-details />
        <DistrictsSelect v-if="$route.path !== '/rural'" hide-details />
        <ReferenceField v-if="!smAndDown" hide-details />
      </div>

      <div
        class="mt-5 align-center grid-list-2"
        :class="{
          'grid-list-2-advanced': advancedSearch,
          'grid-list-2-rural':
            ['/rural'].includes($route.path) && advancedSearch,
        }"
      >
        <PriceRangeSlide />

        <TotalAreaRange
          v-if="['/rural'].includes($route.path) && advancedSearch"
          hide-details
        />

        <CondominiumField
          v-if="!['/rural'].includes($route.path) && advancedSearch"
        />

        <GarageSelect
          v-if="!['/rural'].includes($route.path) && advancedSearch"
          hide-details
        />
        <BedroomsSelect
          v-if="!['/rural'].includes($route.path) && advancedSearch"
          hide-details
        />
        <SuitesSelect
          v-if="!['/rural'].includes($route.path) && advancedSearch"
          hide-details
        />

        <template v-if="!xsOnly && !advancedSearch">
          <ButtonWidget
            @click="advancedSearch = !advancedSearch"
            color="primary"
            height="40"
            outlined
            block
          >
            Busca Avançada
            <v-icon right>fa-search-plus</v-icon>
          </ButtonWidget>

          <ButtonWidget type="submit" height="40" block>
            Buscar
            <v-icon right>fa-search</v-icon>
          </ButtonWidget>
        </template>
      </div>

      <template v-if="xsOnly || advancedSearch">
        <template v-if="!['/rural'].includes($route.path)">
          <div class="mt-5 grid-list-3">
            <BuiltAreaRange
              v-if="!['/rural'].includes($route.path)"
              hide-details
            />

            <TotalAreaRange
              v-if="!['/rural'].includes($route.path)"
              hide-details
            />
          </div>
        </template>

        <div class="mt-5 grid-list-4">
          <CondominiumField v-if="xsOnly" />

          <ReferenceField v-if="smAndDown" hide-details />
          <SearchField hide-details />

          <ButtonWidget
            v-if="!xsOnly"
            @click="advancedSearch = !advancedSearch"
            color="primary"
            height="40"
            outlined
            block
          >
            Busca Avançada
            <v-icon right>fa-search-plus</v-icon>
          </ButtonWidget>

          <ButtonWidget type="submit" height="40" block>
            Buscar
            <v-icon right>fa-search</v-icon>
          </ButtonWidget>
        </div>
      </template>
    </v-form>
  </v-sheet>
</template>

<script>
import BusinessSelect from "./fields/BusinessSelect.vue";
import CategoriesSelect from "./fields/CategoriesSelect.vue";
import DistrictsSelect from "./fields/DistrictsSelect.vue";
import CitiesSelect from "./fields/CitiesSelect.vue";
import CondominiumField from "./fields/CondominiumField.vue";
import ReferenceField from "./fields/ReferenceField.vue";
import PriceRangeSlide from "./fields/PriceRangeSlide.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";
import GarageSelect from "./fields/GarageSelect.vue";
import BedroomsSelect from "./fields/BedroomsSelect.vue";
import SuitesSelect from "./fields/SuitesSelect.vue";
import TotalAreaRange from "./fields/TotalAreaRange.vue";
import BuiltAreaRange from "./fields/BuiltAreaRange.vue";
import SearchField from "./fields/SearchField.vue";

const _data = {
  advancedSearch: false,
  dialog: false,
  priceMax: 0,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    query() {
      return this.$route.query;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    search() {
      const form = this.$refs.form;
      const formData = new FormData(form.$el);

      let path = "";

      if (
        ["/imoveis", "/locacao", "/terrenos", "/rural"].includes(
          this.$route.path
        )
      )
        path = this.$route.path;

      const parameters = [];
      const price = [];
      const builtArea = [];
      const totalArea = [];

      for (var pair of formData.entries()) {
        if (
          ["/imoveis", "/locacao"].includes(this.$route.path) &&
          pair[0] === "finalidade" &&
          pair[1]
        ) {
          if (pair[1] === "Venda") path = "/imoveis";
          else path = "/locacao";
        } else if (["min-price", "max-price"].includes(pair[0]))
          price.push(pair[1]);
        else if (["built-area-min", "built-area-max"].includes(pair[0]))
          builtArea.push(pair[1]);
        else if (["total-area-min", "total-area-max"].includes(pair[0]))
          totalArea.push(pair[1]);
        else if (
          (pair[1] &&
            ![
              "built-area-min",
              "built-area-max",
              "total-area-min",
              "total-area-max",
              "min-price",
              "max-price",
            ].includes(pair[0])) ||
          (!["/imoveis", "/locacao"].includes(this.$route.path) &&
            pair[0] === "finalidade")
        )
          parameters.push(
            encodeURIComponent(pair[0]) + "=" + encodeURIComponent(pair[1])
          );
      }

      if (price.length == 2)
        parameters.push(
          encodeURIComponent("preco") +
            "=" +
            encodeURIComponent(price.join(","))
        );

      if (builtArea.length == 2)
        parameters.push(
          encodeURIComponent("area-construida") +
            "=" +
            encodeURIComponent(builtArea.join(","))
        );

      if (totalArea.length == 2)
        parameters.push(
          encodeURIComponent("area-total") +
            "=" +
            encodeURIComponent(totalArea.join(","))
        );

      if (parameters.length) {
        path += "?" + parameters.join("&");
        this.$router.push({ path });

        this.$emit("search-submit");
      }
    },
    checkAdvancedSearch() {
      if (!this.advancedSearch) {
        const advancedSearch = [
          "garagem",
          "quartos",
          "suites",
          "terreno",
          "construido",
          "q",
        ];

        for (let item = 0; item < advancedSearch.length; item++) {
          if (this.query[advancedSearch[item]]) {
            this.advancedSearch = true;

            item = advancedSearch.length;
          }
        }
      }
    },
  },
  watch: {
    $route() {
      this.checkAdvancedSearch();
    },
  },
  mounted() {
    this.checkAdvancedSearch();
  },
  components: {
    BusinessSelect,
    CategoriesSelect,
    DistrictsSelect,
    CitiesSelect,
    CondominiumField,
    ReferenceField,
    PriceRangeSlide,
    ButtonWidget,
    GarageSelect,
    BedroomsSelect,
    SuitesSelect,
    TotalAreaRange,
    BuiltAreaRange,
    SearchField,
  },
};
</script>

<style lang="scss" scoped>
.search-basic-form::v-deep {
  .grid-list-1,
  .grid-list-2,
  .grid-list-3,
  .grid-list-4 {
    display: grid;
    gap: 15px;

    @media screen and (max-width: 959.9px) {
      gap: 12px;
    }
  }

  .grid-list-1 {
    grid-template-columns:
      calc(25% - 57.5px) calc(25% - 57.5px) calc(25% - 57.5px) calc(
        25% - 57.5px
      )
      170px;

    &.rural {
      grid-template-columns:
        calc(33.33% - 71.5px) calc(33.33% - 71.5px) calc(33.33% - 71.5px)
        170px;

      @media screen and (max-width: 959.9px) {
        grid-template-columns: repeat(3, calc(33.33% - 8px));
      }

      @media screen and (max-width: 599.9px) {
        grid-template-columns: 1fr;
      }
    }

    @media screen and (max-width: 959.9px) {
      grid-template-columns: repeat(2, calc(50% - 6px));
    }

    @media screen and (max-width: 599.9px) {
      grid-template-columns: 1fr;
    }
  }

  .grid-list-2 {
    grid-template-columns: 1fr auto auto;

    @media screen and (max-width: 959.9px) {
      grid-template-columns: repeat(2, calc(50% - 6px));

      & > :first-child {
        grid-column: 1 / -1;
      }
    }

    @media screen and (max-width: 599.9px) {
      grid-template-columns: 1fr;
    }

    &-advanced {
      grid-template-columns: 170px calc(33.33% - 71.5px) calc(33.33% - 71.5px) calc(
          33.33% - 71.5px
        );

      & > :first-child {
        grid-column: 1 / -1;
      }

      @media screen and (max-width: 959.9px) {
        grid-template-columns: repeat(2, calc(50% - 6.5px));
      }
    }

    &-rural {
      grid-template-columns: repeat(2, calc(50% - 6.5px));

      & > :first-child {
        grid-column: initial;
      }

      @media screen and (max-width: 959.9px) {
        grid-template-columns: 1fr;
      }
    }
  }

  .grid-list-3 {
    grid-template-columns: repeat(2, calc(50% - 7px));

    @media screen and (max-width: 959.9px) {
      grid-template-columns: repeat(2, calc(50% - 6px));
    }

    @media screen and (max-width: 599.9px) {
      grid-template-columns: 1fr;
    }
  }

  .grid-list-4 {
    grid-template-columns: calc(100% - 445px) 255px 161px;

    @media screen and (max-width: 959.9px) {
      grid-template-columns: repeat(2, calc(50% - 6px));
    }

    @media screen and (max-width: 599.9px) {
      grid-template-columns: 1fr;
    }
  }

  .v-text-field--outlined {
    fieldset {
      border-color: rgba(204, 190, 192, 0.8);
    }

    input {
      &::placeholder {
        color: var(--v-primary-lighten1);
      }
    }
  }
}
</style>
